
const m = window.require("@ember/deprecated-features");
if (m.default && !m.__esModule) {
  m.__esModule = true;
}
module.exports = m;
